<template>
  <button class="serp__filters--mobile-close-button q-d-block q-d-md-none q-btn q-btn-close q-btn-lg q-rounded-3 q-shadow-sm q-bg-white q-p-3"
          @click="filtersStore.hideFiltersOnMobile">
  </button>
</template>

<script setup lang="ts">
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

const filtersStore = useFiltersStore();
</script>

<style scoped>
.serp__filters--mobile-close-button {
  position: absolute;
  top: 20px;
  right: 1rem;


}
</style>